export interface FirefliesSentiments {
  negative_pct: number;
  neutral_pct: number;
  positive_pct: number;
}

export interface FirefliesCategories {
  questions: string[];
  date_times: string[];
  metrics: string[];
  tasks: string[];
}

export interface FirefliesSpeakerAnalytics {
  speaker_id: number;
  name: string;
  duration: number;
  word_count: number;
  longest_monologue: number;
  monologues_count: number;
  filler_words: number;
  questions: number;
  duration_pct: number;
  words_per_minute: number;
}

export interface FirefliesAnalytics {
  sentiments: FirefliesSentiments;
  categories: FirefliesCategories;
  speakers: FirefliesSpeakerAnalytics[];
}

export interface FirefliesSpeaker {
  id: number;
  name: string;
}

export interface FirefliesAIFilters {
  task: boolean;
  pricing: boolean;
  metric: boolean;
  question: boolean;
  date_and_time: boolean;
  text_cleanup: string;
  sentiment: string;
}

export interface FirefliesSentence {
  index: number;
  speaker_name: string;
  speaker_id: number;
  text: string;
  raw_text: string;
  start_time: number;
  end_time: number;
  ai_filters: FirefliesAIFilters;
}

export interface FirefliesShortSentence {
  index: number;
  speaker_name: string;
  text: string;
  start_time: number;
  end_time: number;
}

export interface FirefliesUser {
  user_id: string;
  email: string;
  name: string;
  num_transcripts: number;
  recent_meeting: string;
  minutes_consumed: number;
  is_admin: boolean;
  integrations: string[];
}

export interface FirefliesMeetingAttendee {
  displayName: string;
  email: string;
  phoneNumber: string;
  name: string;
  location: string;
}

export interface FirefliesMeetingAttendance {
  name: string;
  join_time: number;
  leave_time: number;
}

export interface FirefliesSummary {
  keywords: string[];
  action_items: string[];
  outline: string[];
  shorthand_bullet: string[];
  overview: string;
  bullet_gist: string[];
  gist: string;
  short_summary: string;
  short_overview: string;
  meeting_type: string;
  topics_discussed: string[];
  transcript_chapters: string[];
}

export interface FirefliesMeetingInfo {
  fred_joined: boolean;
  silent_meeting: boolean;
  summary_status: string;
}

export interface FirefliesAppOutput {
  transcript_id: string;
  user_id: string;
  app_id: string;
  created_at: string;
  title: string;
  prompt: string;
  response: string;
}

export interface FirefliesAppsPreview {
  outputs: FirefliesAppOutput[];
}

export interface FirefliesChannel {
  id: string;
}

export interface FirefliesTranscript {
  id: string;
  dateString: string;
  privacy: string;
  analytics: FirefliesAnalytics;
  speakers: FirefliesSpeaker[];
  sentences: FirefliesSentence[];
  title: string;
  host_email: string;
  organizer_email: string;
  calendar_id: string;
  user: FirefliesUser;
  fireflies_users: string[];
  participants: string[];
  date: string;
  transcript_url: string;
  audio_url: string;
  video_url: string;
  duration: number;
  meeting_attendees: FirefliesMeetingAttendee[];
  meeting_attendance: FirefliesMeetingAttendance[];
  summary: FirefliesSummary;
  cal_id: string;
  calendar_type: string;
  meeting_info: FirefliesMeetingInfo;
  apps_preview: FirefliesAppsPreview;
  meeting_link: string;
  channels: FirefliesChannel[];
}

export interface FirefliesWebhookEventBody {
  meetingId: string;
  eventType: string;
  clientReferenceId: string;
}
